module.exports = __webpack_public_path__ + "05a2a52551869e6531174e5060676c97.jpg";